const ProcurementZoneType = {
  GET_PROCUREMENT_ZONE_LIST: 'GET_PROCUREMENT_ZONE_LIST',
  GET_PROCUREMENT_ZONE_LIST_SUCCESS: 'GET_PROCUREMENT_ZONE_LIST_SUCCESS',
  GET_PROCUREMENT_ZONE_LIST_FAIL: 'GET_PROCUREMENT_ZONE_LIST_FAIL',
  SET_PROCUREMENT_ZONE_LIST_REQUEST: 'SET_PROCUREMENT_ZONE_LIST_REQUEST',
  SET_ADD_NEW_ZONE: 'SET_ADD_NEW_ZONE',
  SET_ACTIVE_ZONE_ITEM: 'SET_ACTIVE_ZONE_ITEM',
  RESET_ACTIVE_ZONE_ITEM: 'RESET_ACTIVE_ZONE_ITEM',
  RESET_PROCUREMENT_ZONE_LIST: 'RESET_PROCUREMENT_ZONE_LIST',
  UPDATE_ZONE_LOCATION_LIST: 'UPDATE_ZONE_LOCATION_LIST',
};

export default ProcurementZoneType;
